import http from "../../services/httpService";
import { injectHtml } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../common/global";
import { catchError } from "../../utils/errorUtil";

const props = {
    //ADDRESS BOOK
    addressBookMarker: '#m-my-account-address-book',
    deleteAddress: '.my-account-address-delete'    
};

export function initMyAccounts() {

    if ($(props.addressBookMarker).length) {
        addressBookEvents();
    }
}

//START - PRODUCT PAGE ADD TO BASKET - CORE
async function addressBookEvents() {

    $(props.deleteAddress).off('click').on('click', function () {

        //display a confirmation popup for the delete address request
        var addressId = $(this).data('id');

        deleteAddress(addressId);
    });
}

async function deleteAddress(addressId) {

    //launches a confirmation dialog for a single address deletion
    openDialog({
        ...dialogModel,
        title: 'Delete Address',
        content: 'Confirm the deletion of this address form your address book.',
        confirmButtonText: 'Confirm',
        onConfirm: () => deleteAddressWorker(addressId),
        theme: 'delete'
    });
}

async function deleteAddressWorker(addressId) {

    //manages the deletion of the address (and susequent page reload)
    const requestData = { id: addressId };

    const requestResult = await deleteAddressService(requestData);

    window.location.reload(true);
}

async function deleteAddressService(data) {

    //no TRY CATCH as handled by parent
    //returns json result of delete address attempt
    const response = await http.post('/manage-account/delete-address', data);

    return response.data;
}